import React from 'react';
import {Fab, IconButton} from '@material-ui/core';
import {Add as AddIcon, Delete as DeleteIcon, Edit as EditIcon} from '@material-ui/icons';
import {deleteQuestion, fetchQuestions} from 'api/question';
import {Link} from 'react-router-dom';
import {DeletionConfirm, ThinkscapeTable} from '../../components/common';
import Modal from '../common/Modal';
import QuestionType from './QuestionType';
import Button from '@material-ui/core/Button';
import {isEmpty} from 'lodash';
import {formatErrors} from '../../actions/errors';
import {addFlashMessage} from '../../actions/flash-message';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {createForm} from 'rc-form';
import {SecondaryButton} from '../common/StyledButtons';


export class QuestionList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            showDeleteModal: false,
        };
        this.handleDeleteRow = this.handleDeleteRow.bind(this);
        this.handleDeleteQuestion = this.handleDeleteQuestion.bind(this);
        this.deletionQuestionConfirmBoxRef = React.createRef();
    }

    handleDeleteRow(row){
        this.setState({selectedQuestion: row.id});
        this.deletionQuestionConfirmBoxRef.current.openModal();
    }

    handleDeleteQuestion() {
        deleteQuestion(this.state.selectedQuestion)
            .then(() => {
                this.context.router.history.push('/questions');
                addFlashMessage('Question has been successfully deleted!', 'success');
            })
            .catch(() => {
                addFlashMessage('Failed deleting question!', 'error');
            });
    }

    render() {
        const {open = false} = this.state;

        return (
            <div className="content-box">
                <Modal
                    title=""
                    onClose={() => this.setState({open: false})}
                    open={open}
                    maxWidth="sm"
                >
                    <QuestionType/>
                </Modal>
                <DeletionConfirm
                    ref={this.deletionQuestionConfirmBoxRef}
                    itemName="this question"
                    deleteAction={this.handleDeleteQuestion}
                />
                <h1 className="section-header">
                    <div className="section-title">Question Bank</div>
                </h1>
                <div>
                    <SecondaryButton className="pull-right"
                        onClick={() => this.setState({open: true})}>
                        Add New Question
                    </SecondaryButton>

                    <ThinkscapeTable
                        itemName="questions"
                        searchBoxPlaceholder="Search Questions"
                        getFieldsMapping={(question) => (
                            {
                                name: question.name || '',
                                topic: question.topic,
                                subtopic: question.subtopic,
                                edit: '',
                                actions: '',
                            })
                        }
                        fetchRecords={(args) => fetchQuestions({
                            ...args,
                            extraParams: {...args.extraParams}
                        })}
                        fieldsSettings={
                            {
                                name: {
                                    sortable: true,
                                    fieldText: 'Name',
                                    formatData: (cell, row) => <Link to={`/questions/${row.id}`}>{row.name}</Link>
                                },
                                topic: {
                                    sortable: true,
                                    fieldText: 'Topic'
                                },
                                subtopic: {
                                    sortable: true,
                                    fieldText: 'Subtopic',
                                    formatData: (cell => isEmpty(cell) ? '-' : cell)
                                },
                                edit: {
                                    noPadding: true,
                                    fieldText: 'Edit',
                                    formatData: (cell, row) => (
                                        <IconButton href={`/questions/${row.id}`}>
                                            <EditIcon/>
                                        </IconButton>
                                    ),
                                },
                                actions: {
                                    noPadding: true,
                                    fieldText: 'Delete',
                                    formatData: (cell, row) => (
                                        <IconButton onClick={() => this.handleDeleteRow(row)}>
                                            <DeleteIcon/>
                                        </IconButton>
                                    ),
                                },
                            }
                        }
                    />
                </div>
            </div>
        );
    }
}
const mapDispatchToProps = (dispatch) => ({
    formatErrors: (...args) => dispatch(formatErrors(...args)),
    addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

QuestionList.contextTypes = {
    router: PropTypes.object.isRequired
};

export default connect(
    null,
    mapDispatchToProps
)(createForm()(QuestionList));